import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.formTargets.forEach((form) => {
      form.addEventListener("submit", (e) => {
        if (!confirm("你確定要刪除嗎？")) {
          e.preventDefault()
        }
      })
    })
  }
}